export default "__VITE_ASSET__DbvcsTFD__"